import { SvgIconComponent } from "@mui/icons-material";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { Permission, PermissionValue } from "../../auth/permissions";

// The sections of Settings, grouped as in the side navigation. "soon" sections are listed but not
// built yet. Each active section is a route: /app/settings/<key>.
export type SettingsSection = {
  key: string;
  label: string;
  description: string;
  icon: SvgIconComponent;
  permission: PermissionValue;
  status: "active" | "soon";
};

export type SettingsGroup = { label: string; sections: SettingsSection[] };

export const SETTINGS_ROUTE = "/app/settings";

export const settingsGroups: SettingsGroup[] = [
  {
    label: "School",
    sections: [
      {
        key: "school",
        label: "School Profile",
        description: "Logo, name, address and contact details",
        icon: ApartmentRoundedIcon,
        permission: Permission.CONFIG_SCHOOL_MANAGE,
        status: "active",
      },
    ],
  },
  {
    label: "Finance",
    sections: [
      {
        key: "receipts",
        label: "Fees & Receipts",
        description: "How fee receipts look",
        icon: ReceiptLongRoundedIcon,
        permission: Permission.CONFIG_SCHOOL_MANAGE,
        status: "active",
      },
      {
        key: "payment-gateway",
        label: "Payment Gateway",
        description: "Online fee payments",
        icon: CreditCardRoundedIcon,
        permission: Permission.CONFIG_SCHOOL_MANAGE,
        status: "soon",
      },
    ],
  },
  {
    label: "Communication",
    sections: [
      {
        key: "messaging",
        label: "Messaging",
        description: "SMS to parents and guardians",
        icon: ForumRoundedIcon,
        permission: Permission.CONFIG_SCHOOL_MANAGE,
        status: "soon",
      },
    ],
  },
  {
    label: "Advanced",
    sections: [
      {
        key: "system",
        label: "System",
        description: "Logging and attendance messages",
        icon: TuneRoundedIcon,
        permission: Permission.CONFIG_SYSTEM_MANAGE,
        status: "active",
      },
    ],
  },
];
